import React, { useState, useEffect } from "react";
import ModalComponent from "../../../components/global/modals/ModalComponent";
import LoadableButton from "../../../components/button/LoadableButton";

const UpgradePlanModal = ({
  isOpen,
  setIsOpen,
  plans,
  onSubmit,
  isLoading,
}) => {
  const [selectedPlanId, setSelectedPlanId] = useState(null);

  useEffect(() => {
    if (!isOpen) {
      setSelectedPlanId(null);
    }
  }, [isOpen]);

  const handleSubmit = () => {
    if (selectedPlanId) {
      onSubmit(selectedPlanId);
    }
  };

  return (
    <ModalComponent
      isOpen={isOpen}
      setIsOpen={setIsOpen}
      title="Upgrade Plan"
      width={800}
    >
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 max-h-[60vh] overflow-y-auto p-4">
        {plans?.map((plan) => (
          <div
            key={plan.id}
            className={`border rounded-xl p-4 cursor-pointer transition-all ${
              selectedPlanId === plan.id
                ? "border-secondary bg-blue-50 ring-2 ring-secondary"
                : "border-gray-200 hover:border-blue-300"
            }`}
            onClick={() => setSelectedPlanId(plan.id)}
          >
            <div className="flex justify-between items-start mb-2">
              <h3 className="font-semibold text-lg text-gray-800">
                {plan.name}
              </h3>
              {selectedPlanId === plan.id && (
                <div className="w-5 h-5 bg-secondary rounded-full flex items-center justify-center">
                  <span className="text-white text-xs">✓</span>
                </div>
              )}
            </div>
            
            <div className="flex items-baseline gap-1 mb-2">
              <span className="text-2xl font-bold text-gray-900">
                {plan.amount}
              </span>
              <span className="text-gray-500 text-sm">
                / {plan.duration} Month{plan.duration > 1 ? 's' : ''}
              </span>
            </div>

            <div className="space-y-2 mb-3">
               <p className="text-sm text-gray-600">
                  Total Users: <span className="font-medium">{plan.total_user}</span>
               </p>
               {plan.description && (
                   <p className="text-sm text-gray-500 line-clamp-2">
                       {plan.description}
                   </p>
               )}
            </div>

             {/* Features list if available */}
             {plan.features && plan.features.length > 0 && (
                <div className="space-y-1">
                    {plan.features.slice(0, 3).map((feature, idx) => (
                        <div key={idx} className="flex items-center gap-2 text-xs text-gray-600">
                            <span className="w-1.5 h-1.5 bg-green-500 rounded-full"></span>
                            <span>{feature}</span>
                        </div>
                    ))}
                    {plan.features.length > 3 && (
                        <p className="text-xs text-gray-400 pl-3.5">
                            +{plan.features.length - 3} more features
                        </p>
                    )}
                </div>
             )}
          </div>
        ))}
      </div>

      <div className="flex justify-center mt-6">
        <LoadableButton
          className={`btn-primary ${!selectedPlanId ? 'opacity-50 cursor-not-allowed' : ''}`}
          type="button"
          lable="Send Payment Link"
          loadingLable="Sending..."
          isLoading={isLoading}
          onClick={handleSubmit}
          disabled={!selectedPlanId}
        />
      </div>
    </ModalComponent>
  );
};

export default UpgradePlanModal;
